import { TableCell, TableRow } from '@mui/material';

interface IProps {
  etablishmentName: string;
  repartition?: number;
  threshold?: number;
}

const RowRepartitionTopUp = ({
  etablishmentName,
  repartition,
  threshold,
}: IProps) => {
  return (
    <TableRow data-test={`threshold-list-row-${etablishmentName}`}>
      <TableCell>{etablishmentName}</TableCell>
      <TableCell>{repartition}</TableCell>
      <TableCell>{threshold}</TableCell>
    </TableRow>
  );
};

export default RowRepartitionTopUp;
